var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.route)?_c('a',{staticClass:"sc-button",class:_vm.buttonClassList,attrs:{"href":_vm.href},on:{"click":function($event){return _vm.handleLinkClick($event)}}},[_vm._t("default")],2):_c('button',_vm._g({staticClass:"sc-button",class:_vm.buttonClassList,attrs:{"disabled":_vm.disabled}},_vm.$listeners),[_vm._t("default")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3f960eca","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/lib/components/ScButton.vue
// module id = null
// module chunks = 